import Layout from "@/components/layout";
import AccessRestricted from "@/components/AccessRestricted";
import FilesController from "@/modules/files/FilesController";
import { useHasPermission } from "@/store/authStore";
import { Permission } from "@forgepoint/shared";

/**
 * Vault page. Renders the organization files browser, gated behind the
 * `vault.view` permission with a full-page access denied state otherwise.
 * Edit controls are additionally gated on `vault.edit`.
 * @returns The Vault page, or an access denied state when unauthorized
 */
export default function Files() {
  const canView = useHasPermission(Permission.VAULT_VIEW);
  const canEdit = useHasPermission(Permission.VAULT_EDIT);

  const breadcrumbs = [{ label: "Vault", current: true }];

  if (!canView) {
    return <AccessRestricted breadcrumbs={breadcrumbs} />;
  }

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <FilesController canEdit={canEdit} />
    </Layout>
  );
}
